import { Smartphone, Monitor, NotebookText } from "lucide-react";
import { useProto } from "./ProtoContext";
import { cn } from "@/lib/utils";

const SCREENS = [
  { id: "today", label: "Today" },
  { id: "people", label: "People" },
  { id: "person", label: "Person" },
  { id: "log", label: "Log Care" },
  { id: "overview", label: "Overview" },
];
export const PALETTES = [
  { id: "moss", label: "Care", swatch: "#234F3E" },
  { id: "clay", label: "Clay", swatch: "#B4532A" },
  { id: "harbor", label: "Harbor", swatch: "#2E5B7E" },
];

const Seg = ({ children }) => <div className="inline-flex items-center rounded-full bg-white/10 p-0.5 shrink-0">{children}</div>;
const segBtn = (on) => cn("h-8 px-3 rounded-full text-[13px] font-medium whitespace-nowrap transition-colors inline-flex items-center gap-1.5", on ? "bg-white text-[#1c1a17]" : "text-white/70 hover:text-white");

export const Toolbar = () => {
  const { jump, current, role, setRole, device, setDevice, narrow, palette, setPalette, notesOpen, setNotesOpen, wording, setWording } = useProto();
  return (
    <header className="h-14 bg-[#1c1a17] text-white flex items-center gap-3 px-3 overflow-x-auto no-scrollbar" data-testid="proto-toolbar">
      <span className="text-[13px] text-white/60 whitespace-nowrap pl-1 hidden md:inline">Care · UX concept</span>
      <Seg>{SCREENS.map((s) => <button key={s.id} onClick={() => jump(s.id)} className={segBtn(current === s.id)} data-testid={`proto-screen-${s.id}`}>{s.label}</button>)}</Seg>
      <Seg>
        <button onClick={() => setRole("leader")} className={segBtn(role === "leader")} data-testid="proto-role-leader">Monica · Care Leader</button>
        <button onClick={() => setRole("pastor")} className={segBtn(role === "pastor")} data-testid="proto-role-pastor">David · Pastor</button>
      </Seg>
      <Seg>
        <span className="text-[13px] text-white/60 px-2">Words</span>
        {["A", "B", "C"].map((w) => <button key={w} onClick={() => setWording(w)} className={segBtn(wording === w)} title="Terminology exploration" data-testid={`proto-words-${w}`}>{w}</button>)}
      </Seg>
      {!narrow && (
        <Seg>
          <button onClick={() => setDevice("phone")} className={segBtn(device === "phone")} data-testid="proto-device-phone"><Smartphone size={14} /> Phone</button>
          <button onClick={() => setDevice("desktop")} className={segBtn(device === "desktop")} data-testid="proto-device-desktop"><Monitor size={14} /> Desktop</button>
        </Seg>
      )}
      <Seg>
        {PALETTES.map((p) => (
          <button key={p.id} onClick={() => setPalette(p.id)} className={segBtn(palette === p.id)} title={`${p.label} palette (exploration)`} data-testid={`proto-palette-${p.id}`}>
            <span className="h-3 w-3 rounded-full ring-1 ring-white/50" style={{ background: p.swatch }} />{p.label}
          </button>
        ))}
      </Seg>
      {(narrow || device === "desktop") && (
        <button onClick={() => setNotesOpen(!notesOpen)} className={segBtn(notesOpen)} data-testid="proto-notes-toggle"><NotebookText size={14} /> Notes</button>
      )}
    </header>
  );
};
